export default __webpack_public_path__ + "static/media/seo-keywords-on-enterprise-nudge.997c1001.png";